import React, { useContext } from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import RecipeForm from '../components/recipes/RecipeForm';
import { RecipeContext } from '../contexts/RecipeContext';
import { useNavigate } from 'react-router-dom';

const AddRecipePage: React.FC = () => {
  const { addNewRecipe } = useContext(RecipeContext);
  const navigate = useNavigate();

  const handleSubmit = (recipeData: any) => {
    addNewRecipe(recipeData);
    // Afficher un message de succès
    alert('Recette ajoutée avec succès !');
    // Rediriger vers la page des recettes
    navigate('/recipes');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow py-20 bg-light">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h1 className="text-3xl font-bold mb-4">Ajouter une nouvelle recette</h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Partagez votre création culinaire avec style ! Remplissez le formulaire ci-dessous pour ajouter une nouvelle recette à votre collection personnelle.
            </p>
          </div>
          
          <RecipeForm onSubmit={handleSubmit} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AddRecipePage;
